

define(['jquery', 'lodash', 'eventEmitter/EventEmitter', '../core/video'], function ($, _, EventEmitter, YoutubeVideo) {

    function Modal () { }
    Modal.prototype = _.clone(EventEmitter.prototype);

    Modal.prototype.init = function () {
        var _this = this;

        _this.activateModals();
        _this.emit('init');
    };

    Modal.prototype.activateModals = function() {
        var _this = this;

        _this.getModals$().map( function (index, modalHTMLelement) {

            var $modal = $(modalHTMLelement);
            var modalVideo = $modal.hasClass('modal--video');
            var modalVideoInstance;

            if(modalVideo){

                var modalVideoItem = $modal.find('[data-youtube-video-id]');
                var videoKey = modalVideoItem.data('youtubeVideoId');

                modalVideoInstance = new YoutubeVideo(videoKey, modalVideoItem);

            }

            $(modalHTMLelement).modal({

                ready: function(modal, trigger){

                    if(modalVideoInstance) {
                        try {
                            modalVideoInstance.playVideo();
                        } catch(e){ console.log('play video exception', e) }
                    }

                },
                complete: function(){
                    if(modalVideoInstance) {
                        try {
                            modalVideoInstance.pauseVideo();
                        } catch(e){
                            // console.log('pause video exception', e);
                        }
                    }
                }

            });

            if($modal.data('initialOpen')){

                setTimeout(function(){
                    _this.openModal(modalHTMLelement);
                }, 100);
            }
        });

        _this.openModal()

    };

    Modal.prototype.openModal = function(modalHTMLelement) {
        $(modalHTMLelement).modal('open');
    };

    Modal.prototype.getTriggers$ = function () {
        return $('.modal-trigger');
    };

    Modal.prototype.getModals$ = function () {
        return $('.modal:visible');
    };

    return Modal;

});



// WEBPACK FOOTER //
// ./Private/Scripts/modules/modal.js